import React, { Component } from "react";
// Style
import "../../styles/VerifyChangePassword.css";

export default class VerifyChangePassword extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  // Go to create new password link
  handleChangePassword = () => {
    this.props.resetAndUpdateFlag(true, "createNewPassword", true);
  };

  render() {
    return (
      <div className="verifyPassword-modal">
        <div className="row">
          <div className="col-12">
            <h1 className="fs-20 text-dark fw-bold">Change Your Espotz Account Password</h1>
            <p className="horizontal-line-1"></p>
            <p className="fw-bold fs-16 text-white-50 mt-3">Hi User,</p>
            <p className="fs-16 mt-3 text-dark">
              We received a request to change the password for your Espotz account. For your
              security, we need to verify this action. Please click the button below to continue
              with the password change process. This link will be valid for 24 hours.
            </p>
            <button
              className="change-password-button fs-20 fw-500 text-white cursor-pointer border-0 rounded-10"
              onClick={this.handleChangePassword}
            >
              Change Password
            </button>
            <p className="question-text fs-12 fw-400 text-start ">
              Did you receive this email without signing up?
              <span className="cursor-pointer" style={{ color: "blue" }}>
                {" "}
                Click Here
              </span>
            </p>
            <p className="regards-text fs-16 fw-bold">Regards,</p>
            <p className="regards-text fs-16 fw-bold mb-2">Team Espotz</p>
            <p className="horizontal-line-2"></p>

            <p className="disclaimer-text fs-10">
              This email was sent to you because you requested a password change for your Espotz
              account. If you did not make this request, please contact our support team
              immediately.
            </p>
            <p className="disclaimer-text fs-10">
              For security purposes, this password reset link will expire in 24 hours. Please ensure
              you complete the process within this timeframe.
            </p>
            <p className="disclaimer-text fs-10">
              © {new Date().getFullYear()} Espotz. All rights reserved. Your privacy and security
              are important to us. For more information, visit our Privacy Policy and Terms of
              Service.
            </p>
          </div>
        </div>
      </div>
    );
  }
}
